export enum GroupImageEnum {
  Shielded = 'Shielded',
  Google = 'Google',
  SoleTenant = 'Sole-tenant',
  ShieldedVM= 'Shielded VM',
  Byol = 'BYOL',
  Custom = 'Custom',
  Windows10 = 'w10'
}
